export default class SmartCaptcha {
    static render(element, options = {}) {
        const baseOptions = {
            sitekey: SmartCaptcha._clientKey,
            hl: 'ru',
            ...options
        }

        if ('smartCaptcha' in window) {
            return window.smartCaptcha.render(element, baseOptions)
        }

        return undefined
    }

    static init () {
        const nodes = document.querySelectorAll(SmartCaptcha.smartCaptchaSelector)
        nodes.forEach((el) => {
            const id = SmartCaptcha.render(el, {
                callback: (token) => SmartCaptcha.captchaCallback(token, el)
            })
            if (id !== undefined) {
                el.dataset.scWidgetId = String(id)
            }
        })

        document.addEventListener('bxmod:dialog:shown', function (e) {
            const root = (e.detail && e.detail.dialog) ? e.detail.dialog : document;
            const nodes = root.querySelectorAll(SmartCaptcha.smartCaptchaSelector);

            nodes.forEach(function (el) {
                const id = SmartCaptcha.render(el, {
                    callback: (token) => SmartCaptcha.captchaCallback(token, el)
                })
                if (id !== undefined) {
                    el.dataset.scWidgetId = String(id)
                }
            });
        });
    }

    // если капча успешна, активируем чекбокс и триггерим
    static captchaCallback(token, el) {
        const input = el.closest(".smartcaptcha-block").querySelector(".js-smart-captcha-input")

        if (input) {
            input.checked = true // активируем чекбокс
            $(input).trigger("change")
            return
        }
    }
}


SmartCaptcha._clientKey = "ysc1_fHOjw9aUu0BVLzYeOGciPX3wsCCmGeFJe37RHyPI40ccdab3"
SmartCaptcha._backendCaptchaValidateURL = "https://decorazza.ru/check-captcha/"
SmartCaptcha.smartCaptchaSelector = ".js-smart-captcha"
